import React from 'react';
import styled from 'styled-components';
import { MenuButton } from './MenuButton';

export const Header = () => {
  return (
    <Container>
      <div>
        <h1>Dobrodosli <br/> Memories Bar</h1>
      </div>
      <hr />
      <MenuButton />
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  max-width: 670px;
  text-align: center;

  h1{
    color: #cbb16d;
    font-size: 2.5rem;
    margin-bottom: 1.87rem;
  }

  hr{
    border: 3px solid #fff;
    border-radius: 5px;
    width: 90%;
    margin: auto;
    margin-bottom: 1.87rem;
  }
`;
